import { render } from "./ConquerWorld.vue?vue&type=template&id=079e4618&scoped=true"
const script = {}

import "./ConquerWorld.vue?vue&type=style&index=0&id=079e4618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079e4618"]])

export default __exports__